export const IconMixins = {
	methods: {
		base64Encode (data: any): Promise<any> {
			return new Promise((resolve, reject) => {
				const reader = new FileReader()
				reader.readAsDataURL(data)
				reader.onload = () => resolve(reader.result)
				reader.onerror = error => reject(error)
			})
		},
		getIconImage (image: any): string {
			const identifier = image.charAt(0)
			return `data:image/${imageEncodeType.get(identifier)};base64,` + image
		}
	}
}

export const imageEncodeType: Map<string, string> = new Map([
	["/", "jpg"],
	["i", "png"],
	["R", "gif"]
])
